import { getApiDomain } from "../config";
import Sign from "../models/Sign";
import SignVocab from "../models/SignVocab";
import useFetch from "./useFetch";


export const useSignsByName = (name: string) => {
    const params = new URLSearchParams({ name }).toString();
    return useFetch<Sign[]>(
        !name ? '' : `${getApiDomain()}/signs/?${params}`,
        'GET',
        null,
        [name]
    );
};

export const useSignVocabs = (sign_id: number, dependencies: any[]) => {
    return useFetch<SignVocab[]>(
        sign_id < 0 ? '' : `${getApiDomain()}/vocabs/${sign_id}`,
        'GET',
        null,
        dependencies
    );
}

export const useSignIsLearnt = (sign_id: number, dependencies: any[]) => {
    return useFetch<boolean>(
        sign_id < 0 ? '' : `${getApiDomain()}/practice/isLearnt/${sign_id}`,
        'GET',
        null,
        dependencies
    );
}

export const usePracticeSign = (dependencies: any[]) => {
    return useFetch<Sign>(
        `${getApiDomain()}/practice/`,
        'GET',
        null,
        dependencies
    );
}

export const useVocabSigns = (vocab_id: number, dependencies: any[]) => {
    return useFetch<Sign[]>(
        vocab_id < 0 ? '' : `${getApiDomain()}/vocabs/signs/${vocab_id}`,
        'GET',
        null,
        dependencies
    );
}

export const usePracticeCount = (dependencies: any[]) => {
    return useFetch<number>(
        `${getApiDomain()}/achievements/practices_count`,
        'GET',
        null,
        dependencies
    )
}

export const useLearntCount = (dependencies: any[]) => {
    return useFetch<number>(
        `${getApiDomain()}/achievements/learnt_count`,
        'GET',
        null,
        dependencies
    )
}

export const useDaysPracticeCount = (dependencies: any[]) => {
    return useFetch<number>(
        `${getApiDomain()}/achievements/days_practice_count`,
        'GET',
        null,
        dependencies
    )
}

export const usePracticeTodayCount = (dependencies: any[]) => {
    return useFetch<number>(
        `${getApiDomain()}/achievements/practices_today_count`,
        'GET',
        null,
        dependencies
    )
}

export const useRecordDayPracticeCount = (dependencies: any[]) => {
    return useFetch<{date: Date, count: number}>(
        `${getApiDomain()}/achievements/record_day_practice_count`,
        'GET',
        null,
        dependencies
    )
}

export const usePracticesByDay = (date: Date, dependencies: any[]) => {
    return useFetch<{day: Date, count: number}[]>(
        `${getApiDomain()}/achievements/practices_by_day`,
        'POST',
        date,
        dependencies
    )
}

export const useStreak = (dependencies: any[]) => {
    return useFetch<{streak: number, active: boolean}>(
        `${getApiDomain()}/achievements/streak`,
        'GET',
        null,
        dependencies
    )
}
